import { observer } from 'mobx-react-lite';
import React from 'react';
import { getFileIcon } from '../../../common/file-icon/get-file-icon';
import { useStores } from '../../../common/hooks';
import './UploadLogoSection.scss';
import { Text } from '@fluentui/react-components';
import DocumentFile from '../../shared-components/DocumentFile';

const UploadLogoSectionImpl: React.FC = () => {
  const {
    reviewQuestionnairePageUiStore,
  } = useStores();

  return (
    <section
      className='review-questionnaire-page__section review-questionnaire-page__section--logo'
    >
      <Text
        block
        weight='semibold'
        size={400}
        as='h3'
      >
        Logo
      </Text>
      {
        reviewQuestionnairePageUiStore.questionnaire?.logo
          && reviewQuestionnairePageUiStore.questionnaire.logo.uploadedMediaId > 0 ?
          <DocumentFile
            filename={reviewQuestionnairePageUiStore.questionnaire.logo.originalFileName}
          /> : <Text>No logo uploaded</Text>
      }
    </section>
  );
}

export const UploadLogoSection = observer(UploadLogoSectionImpl);
